<template>
  <div v-if="visible" class="context-menu" :style="{ top: position.y + 'px', left: position.x + 'px' }" ref="menu">
    <div class="user-info">
      <Avatar :label="user.nickname.charAt(0).toUpperCase()" size="small" class="mr-2"
        style="background-color:#2196F3; color: #ffffff" shape="circle" v-if="!user.avatar" />
      <Avatar :image="$utils.getAvatar(user.avatar)" size="small" class="mr-2" style="background-color:#2196F3;  color: #ffffff"
        shape="circle" v-else />
      <div class="user-details">
        <div class="nickname">{{ user.nickname }}</div>
        <span class="age_gender" :class="$utils.getClass(user.gender)" v-html="$utils.getAgeSex(user)"></span>
      </div>
    </div>
    <button @click="emitAction('message')">{{ $t('dialogs.user_context_actions.send_message') }}</button>
    <button @click="emitAction('showProfile')">{{ $t('dialogs.user_context_actions.showProfile') }}</button>
    <button @click="emitAction('gift')">{{ $t('dialogs.user_context_actions.sendGift') }}</button>
    <button @click="emitAction('addFollow')" v-if="!is_following">{{ $t('dialogs.user_context_actions.add_friend')
      }}</button>
    <button @click="emitAction('removeFollow')" v-if="is_following">{{ $t('dialogs.user_context_actions.remove_friend')
      }}</button>
    <button @click="emitAction('block')" v-if="!is_blocked">{{ $t('dialogs.user_context_actions.block') }}</button>
    <button @click="emitAction('unblock')" v-if="is_blocked">{{ $t('dialogs.user_context_actions.unblock') }}</button>
    <button @click="emitAction('kick')">{{ $t('dialogs.user_context_actions.kick') }}</button>
  </div>
</template>

<script>
export default {
  name: 'UserContextMenu',
  props: ['user', 'blocks', 'follows'],
  data() {
    return {
      is_blocked: false,
      is_following: false,
      visible: false,
      position: { x: 0, y: 0 }
    };
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    show(event) {
      event.preventDefault();
      this.visible = true;

      this.$nextTick(() => {
        const menuWidth = this.$refs.menu.offsetWidth;
        const menuHeight = this.$refs.menu.offsetHeight;
        const mainContent = document.getElementById('main_content_easychat');
        const maxWidth = mainContent.clientWidth;
        const maxHeight = mainContent.clientHeight;

        let x = event.clientX;
        let y = event.clientY;

        if (x + menuWidth > maxWidth) {
          x = maxWidth - menuWidth;
        }

        if (y + menuHeight > maxHeight) {
          y = maxHeight - menuHeight;
        }

        this.position = { x, y };
        event.stopPropagation();
      });
    },


    hide() {
      this.visible = false;
    },
    emitAction(action) {
      this.hide();
      this.$emit('select', action);
    },
    handleClickOutside(event) {
      if (this.$refs.menu && !this.$refs.menu.contains(event.target)) {
        this.hide();
      }
    }
  },
  watch: {
    visible() {
      if (this.follows.find(c => c.id === this.user.user_id)) {
        this.is_following = true;
      } else {
        this.is_following = false;
      }

      if (this.blocks.find(c => c.target_id == this.user.user_id)) {
        this.is_blocked = true;
      } else {
        this.is_blocked = false;
      }
    }
  },

};
</script>

<!-- Stilleriniz -->


<style scoped>
.context-menu {
  position: absolute;
  z-index: 1000;
  background: white;
  border: 1px solid #ccc;
  padding: 10px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

svg.gender-icon {
  height: 16px;
}

.context-menu .user-info {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.context-menu .avatar {
  width: 40px;
  height: 40px;
  border-radius: 20px;
  margin-right: 10px;
}

.context-menu .user-details {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}

.context-menu .nickname {
  margin-right: 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.context-menu .gender-badge {
  width: 20px;
  height: 20px;
}

.context-menu button {
  display: block;
  width: 100%;
  padding: 5px;
  border: none;
  background: none;
  text-align: left;
  cursor: pointer;
}

.context-menu button:hover {
  background-color: #f0f0f0;
}
span.age_gender {
  position: static;
}
</style>